import React, { useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { colors, fonts, glyphs, useMediaQuery } from "../../../Styles";
import { NewInput, NewSelect, CheckBox, CheckStyles, NewInputList } from "../..";
import { DataObj, getLabelFromKey, ListStyle_Types, NewInputListHandles, ReportData } from "../../../Definitions";
import { getDataLevelFromKey } from "../../../Definitions/valueTypes";

interface Lvl1_Props {
  reportData?: ReportData
  onReportDataChange: (data: ReportData) => void
}

export default function ReportModalLvl1({ reportData, onReportDataChange}:Lvl1_Props) {
  const { t } = useTranslation()
  // const inputRef = useRef<NewInputListHandles>(null)
    // const [message, setMessage] = useState<string|null>(null)
  
  const mobileXs = useMediaQuery(`(max-width: 805px)`);
  
  // Archive Options
  const archiveOptions = [    
    { label: t("no", {defaultValue: "no"}), id: 0 },
    { label: t("yes", {defaultValue: "yes"}), id: 1 },
  ]

  // Report Data
  const _reportData = useMemo(() => {
    const reportName = reportData && reportData.name ? reportData.name : undefined
    const reportArchived = reportData && reportData.archived === true ? archiveOptions[1] : archiveOptions[0]
    
    const startDate = reportData && reportData.startDate ? reportData.startDate : Date.now()
    const endDate = reportData && reportData.endDate ? reportData.endDate : Date.now()

    return {
      reportName,
      reportArchived,
      startDate,
      endDate
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportData])

  // Data Levels
  const dataLevels = useMemo(() => {
    const _dataLevels: DataObj[] = [
      "animal_number",
      "animal_group_id", 
      "system_id"
    ]

    return _dataLevels.map((param, index) => {
      const label = getLabelFromKey(param);
      
      return (
        <CheckBox 
          key={index} 
          text={t(`params.${label}`, {defaultValue: `${label}`})}
          checkStyle={CheckStyles.blue} 
          isChecked={reportData && reportData.dataLevel === getDataLevelFromKey(param)}
          onChange={() => onReportDataChange({ ...reportData, reportId: reportData?.reportId || 0, dataLevel: getDataLevelFromKey(param)})}
        />
      )
    })

  }, [onReportDataChange, reportData, t])

  // Handled date values // TODO
  // const HandleDateValues = () => {
  //   let startDate;
  //   let endDate;

  //   if (inputRef && inputRef.current && inputRef.current.refs.current) {
  //     startDate = inputRef.current.refs.current[0]?.value
  //     endDate = inputRef.current.refs.current[1]?.value
  //   }

  //   if (!startDate) {
  //     inputRef.current?.refs.current[0]?.setError()
  //     setMessage(t("reportPages.missingStartdate", { defaultValue: "start date is missing" }))
  //   } else if (!endDate) {
  //     inputRef.current?.refs.current[1]?.setError()
  //     setMessage(t("reportPages.missingEnddate", { defaultValue: "end date is missing" }))
  //   }
  // }

  return (
    <div style={{ width: "100%", margin: "20px 0px 0px 0px" }}>
      <div style={{ display: "flex", flexWrap: "wrap", alignItems: "start", justifyContent: "center", columnGap: "40px", rowGap: "10px", paddingBottom: "20px"}}>
        <NewInput
          header={t("reportPages.reports.reportName", {defaultValue: "Report Name"})}
          onChange={(value) => onReportDataChange({...reportData, reportId: reportData?.reportId || 0, name: value, archived: true})}
          valueOverrides={{ defaultValue: _reportData.reportName }}
          isRequired
          isClearable
        />      
        {/* <NewInputList //TODO: replace the two <NewInput/> with this
          ref={inputRef}
          headers={[t("reportPages.reports.startDate", {defaultValue: "start date"}), t("reportPages.reports.endDate", {defaultValue: "end date"})]}
          placeholders={["", ""]}
          isRequired={[true, true]}
          isClearable
          startEnhancers={[glyphs.Calendar({}), glyphs.Calendar({})]}
          valueOverrides={{
            valueTypes: ["date", "date"]
          }}
          listOverrides={{
            listStyle: ListStyle_Types.vertical,
            listGap: "10px"
          }}
        /> */}
        <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
         <NewInput
            header={t("reportPages.reports.startDate", {defaultValue: "start date"})}
            valueOverrides={{ valueType: 'date'}}
            onChange={(e) => onReportDataChange({...reportData, reportId: reportData?.reportId || 0, startDate: new Date(e).getTime()})}
            startEnhancer={glyphs.Calendar({})}
            isRequired
            isClearable
          />
          <NewInput
            header={t("reportPages.reports.endDate", {defaultValue: "end date"})}
            valueOverrides={{ valueType: 'date'}}
            onChange={(e) => onReportDataChange({ ...reportData, reportId: reportData?.reportId || 0, endDate: new Date(e).getTime() })} 
            startEnhancer={glyphs.Calendar({})}
            isRequired
            isClearable
          />
        </div>
      </div>
      
      <div style={{ borderTop: "2px solid " + colors.blueDarkSecondary, borderBottom: "2px solid " + colors.blueDarkSecondary, padding: "10px 0px", maxHeight: "200px", display: "flex", alignItems: "start", justifyContent: "center", flexDirection: "column", gap: "10px" }}>
        <p style={{ ...fonts.header, ...fonts.textShadow, ...fonts.fontSize4, color: colors.greyLightTertiary, padding: "0px 0px 0px 22px" }}>{t("reportPages.reports.dataLevel", { defaultValue: "data level" })}</p>
        <div style={{width: "fit-content", display: "flex", flexWrap: "wrap", columnGap: "60px", rowGap: "10px", margin: "0 auto", flexDirection: mobileXs ? "column" : "row"}}>
          {dataLevels}
          </div>  
      </div>
    </div>
  )
}